import { allowedExamsExperiments } from '@/apps/experiments/experimentsMap'
import { getExamName } from '@/util/examUtils'
import { availableActivities } from '@/util/config'

const SET_ACTIVITIES = 'SET_ACTIVITIES'
const ADD_ASSESSMENT = 'ADD_ASSESSMENT'

const ALLOWED_EXAMS = [
  'EXAM_FLANKER',
  'EXAM_GO_NO_GO',
  'EXAM_TRAILS',
  'EXAM_PAIRED_ASSOCIATION',
  'EXAM_PROCESSING_SPEED',
  'EXAM_IMPRINT_MEMORY_ASSESSMENT',
  ...allowedExamsExperiments
]

export default {
  namespaced: true,
  state: () => ({
    activities: undefined,
    assessments: []
  }),
  getters: {
    /**
     * Used by ExamStore to find a (not started) exam based on
     * the root path, so that we can properly start perception
     * using the assessment ID
     *
     * @param root0
     * @param root0.activities
     */
    getActivityByExamName: ({ activities }) => examName => activities.find(
      a => a.data_properties_values.exam_type === examName
          && a.progress_status === 'not started'
    ),
    getActivityIdByExamName:
      (state, getters) => examName => getters
        .getActivityByExamName(examName)
        .instance_reference_id,
    flattenedActivities: ({ activities }, getters, rootState, rootGetters) => ({ completed }) => (
      activities
        && activities
          .map(
            ({
              module_task_priority,
              task: {
                domains_measured,
                duration,
                title,
                icon_image: { url }
              } = {},
              data_properties_values: {
                exam_subtype,
                exam_type,
                exam_code
              } = {},
              progress_status,
              updated_at,
              user_id
            }) => ({
              priority: module_task_priority,
              isTodo: progress_status === 'not started',
              isProcessing: progress_status === 'processing',
              isCompleted: progress_status === 'completed',
              updated_at: new Date(updated_at),
              domains_measured,
              duration,
              title,
              icon_image: url,
              exam_type,
              exam_subtype,
              exam_code,
              user_id,
              name: getExamName(exam_type),
              hasCameraError:
                rootGetters['video/getCameraHasError'] && exam_type === 'EXAM_IMPRINT_MEMORY_ASSESSMENT'
            })
          )
          .filter(({
            exam_type, isCompleted, isTodo, isProcessing
          }) => ALLOWED_EXAMS.includes(exam_type)
            && (completed ? isCompleted : (isTodo || isProcessing)))
    )
  },
  mutations: {
    [ADD_ASSESSMENT](state, assessment) {
      state.assessments.push(assessment)
    },
    [SET_ACTIVITIES](state, activities) {
      state.activities = activities
    }
  },
  actions: {
    resetActivities({ commit }) {
      commit(SET_ACTIVITIES, undefined)
    },
    async getActivities({ commit }) {
      try {
        const historicalActivities = []
        const newActivities = availableActivities
        commit(SET_ACTIVITIES, newActivities.concat(historicalActivities))
      } catch (e) {
        console.warn('Unable to get activities')
      }
    }
  }
}
